import type { BankLimits } from '../../../generated-types';

export interface PaymentLimitsState {
    maxTransactionAmount?: number;
    maxMonthlyTransactionAmount?: number;
    bankLimits?: BankLimits;
}

export const paymentLimitsInitialState: PaymentLimitsState = {
    maxTransactionAmount: undefined,
    maxMonthlyTransactionAmount: undefined,
    bankLimits: undefined,
};
